// структура элементов для добавления информации о новом питомце для админа
<template>
  <v-form>
    <v-container fluid>

      <v-flex xs12 sm12 md12 >

        <v-card elevation="0">
          <v-card-title class="blue-grey--text text-md-h4 text-sm-h5 text-xs-h6 font-weight-bold ">
            Добавить событие
          </v-card-title>
        </v-card>
      </v-flex>

      <v-alert
        color="#2A3B4D"
        dark
        dense
        dismissible
        close-text="Закрыть"
        align="left"
      >
        Вы можете загрузить 3 фотографии, размер каждой не должен превышать 3 мегабайта. 
        <br> При фотографировании телефоном желательно установить в настройках камеры размер фотографий 1:1
      </v-alert>

    <v-card  class="my-5" elevation='0'>
        <v-card-actions>
        <handy-uploader
          :documentAttachment.sync="handyAttachments"
          :fileUploaderType="'thumbnail'"
          :fileAccept="'image/png,image/gif,image/jpeg,image/webp'"
          :maxFileSize="3000"
          :imageCompressor="true"
          :imageCompressLevel="0.35"
          :maxFileCount="3"
          :badgeCounter="false"
          :thumb="false"
          :changeFileName="true"
          :addFileDescription="true"
          :addFileTag="false"
        >
        </handy-uploader>
      </v-card-actions>
    </v-card>

      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
        >
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date"
                label="Дата публикации"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-text-field
        v-model="newsTitle"
        
        clearable
        clear-icon="mdi-close-circle"
        label="Тема"
        type="text"
      ></v-text-field>

<QuillEditor class="mt-5 mb-7"></QuillEditor>

      <v-progress-linear
        v-if="progress > 0"
        v-model="progress"
        height="25"
        class="my-2"
      >
        <strong>{{ Math.ceil(progress) }}%</strong>
      </v-progress-linear>      

      <v-row>
        <v-btn 
          :to="{name:'mercy'}"
          class="mx-4 mt-3 pr-2 text-subtitle-1"
          color="error"
          width="152px"
          dark
        >Отменить<v-icon size="25" class="ml-2 ">mdi mdi-close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn 
          @click="createID"
          class="mx-4 mt-3 pr-2  text-subtitle-1"
          color="success"
          width="152px"
          dark
          >Добавить<v-icon size="25" class="ml-2 pb-1">mdi mdi-check</v-icon>
        </v-btn>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import handyUploader from "handy-uploader/src/components/handyUploader";
import firebase from "firebase/app";
import Vue from "vue";
import QuillEditor from './QuillEditor'

export default {
  data() {
    return {
      newsTitle: '',
      id: '',
      handyAttachments: [],
      imgfile: [],
      progress: 0,
      imagesObj: {},
      text: '',
      imgIndexArr: [],
      mainImgIndex: '',
      checkNewIMG: false,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
    };
  },

created () {
    return this.$store.dispatch('DELETE_QUILL_HTML');
  },

  

  methods: {


    // загрузка нового изображения в БД
    loadNewImage() {
      let me = this;
      let arr = [];
      let imgNamesArr = [];
      let imgObject;
      let newImageName = "";
      arr = this.handyAttachments;

    // проверка на изменение фото
    if (arr.length != 0) {
      for (let index = 0; index < arr.length; index++) {
        this.imgfile = arr[index];
        
        // // проверка на изменение фото
        // if (this.imgfile != undefined) {
          Object.keys(this.imgfile).forEach((element)  => {  
            imgObject = this.imgfile[element].base64;
            // имя нового изображения
            newImageName = this.imgfile[element].name;
            imgNamesArr.push(newImageName);

            // Create the file metadata
            var metadata = {
              contentType: "image/jpeg",
            };

            // Base64 formatted string
            var message = imgObject;
            var ref = Vue.$storageRef.child("newsIMG/" + newImageName + this.id);
            // Upload file and metadata to the object ''images/' + newImageName'
            var uploadTask = ref.putString(message, "base64", metadata);

            // Listen for state changes, errors, and completion of the upload.
            uploadTask.on(
              firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
              function (snapshot) {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                me.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                // console.log("Upload is " + me.progress + "% done");
                switch (snapshot.state) {
                  case firebase.storage.TaskState.PAUSED: // or 'paused'
                    // console.log("Upload is paused");
                    break;
                  case firebase.storage.TaskState.RUNNING: // or 'running'
                    // console.log("Upload is running");
                    break;
                }
              },
              function (error) {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                  case "storage/unauthorized":
                    // User doesn't have permission to access the object
                    break;

                  case "storage/canceled":
                    // User canceled the upload
                    break;

                  case "storage/unknown":
                    // Unknown error occurred, inspect error.serverResponse
                    break;
                }
              },
              function () {
                // Upload completed successfully, now we can get the download URL
                uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then(function (downloadURL) {
                    // me.newImageURL = downloadURL;
                    // me.imagesObj[imgNamesArr[index] + me.id] = downloadURL;
                    let imgIndex = imgNamesArr[index] + me.id;
                    me.mainImgIndex = imgIndex;
                    me.imagesObj[imgIndex] = downloadURL;
                    me.imgIndexArr.push(imgIndex);
                  })
                  .then(function () {
                    me.checkNewIMG = true;
                    me.loadNewInfo();
                  });
              }
            );
           
          });
        
      }
    } else {
        me.checkNewIMG = false;
        me.loadNewInfo();
      }
   
    },
    
    // create new id
    createID () {
      // Add a new document with a generated id in the "pets" collection 
      let db = Vue.$db.collection("news");
      db.add({})
      .then((docRef) => {
        this.id = docRef.id;
        // console.log("Document written with ID: ", this.id);
      })
      .then(() => {
          // Upload image to Storage
          this.loadNewImage()
        })
    },

  

    // загрузка нового описания в БД
    loadNewInfo() {
      
        // let mainImage = '';
        // if (this.imagesObj[this.mainImgIndex] == undefined) {
        //   mainImage = 'https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/logo%2FShelterLogoMap.png?alt=media&token=a3056403-cb07-4e47-848d-92226aa29684'
        // } else {
        //   mainImage = this.imagesObj[this.mainImgIndex]
        // }
      // Add a new document with a generated id in the "pets" collection 
      let db = Vue.$db.collection("news");

      // проверка обновилось ли картинка
      if (this.checkNewIMG) {

        db.doc(this.id).update({
          newsTitle: this.newsTitle,
          // description: this.description,
          id: this.id,
          images: this.imagesObj,
          mainImg: this.imagesObj[this.mainImgIndex],
          imgIndexArr: this.imgIndexArr,
          emojiText: this.$store.getters.getQuillText,
          userDate: this.date,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        })
        .then(() => {
          // // console.error("Новый питомец добавлен в базу!");
          // // переход на страницку с питомцами
          this.$router.push("/mercy").catch(()=>{});
        })
        .catch((error) => {
            console.error("Error adding document: ", error);
        });
      } else {

        db.doc(this.id).update({
          newsTitle: this.newsTitle,
          // description: this.description,
          id: this.id,
          images: this.imagesObj,
          mainImg: require('../assets/ShelterLogoMainPage.png'),
          imgIndexArr: this.imgIndexArr,
          emojiText: this.$store.getters.getQuillText,
          userDate: this.date,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        })
        .then(() => {
          // // console.error("Новый питомец добавлен в базу!");
          // // переход на страницку с питомцами
          this.$router.push("/mercy").catch(()=>{});
        })
        .catch((error) => {
            console.error("Error adding document: ", error);
        });
      }
    },

  },

  // computed: {
  //     editor() {
  //       return this.$refs.myQuillEditor.quill
  //     }
  //   },
  //   mounted() {
  //     console.log('this is current quill instance object', this.editor)
  //   },



  components: {
    handyUploader,
    // TextareaEmojiPicker,
    QuillEditor
  },
};
</script>

<style>
/* .home-page {
  padding-top: 50px;
} */
</style>